import { LucideIcon } from 'lucide-react';
import React from 'react';

interface SecondaryButtonProps {
  children: React.ReactNode;
  icon?: LucideIcon;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  icon: Icon,
  onClick,
  type = 'button',
  className = '',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`
        px-4 py-2.5
        border border-neutral-300 dark:border-neutral-700
        text-neutral-700 dark:text-neutral-300
        hover:bg-neutral-50 dark:hover:bg-neutral-900
        rounded-lg
        transition-colors
        flex items-center gap-2
        ${className}
      `
        .trim()
        .replace(/\s+/g, ' ')}
    >
      {Icon && <Icon className="w-4 h-4" />}
      <span className="leading-none">{children}</span>
    </button>
  );
};
